import { render, staticRenderFns } from "./TopCard.vue?vue&type=template&id=fff79766&"
var script = {}
import style0 from "./TopCard.vue?vue&type=style&index=0&id=fff79766&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports